import React from "react";
import Sidebar from "containers/sidebar/sidebar";
import cls from "./settings.module.scss";
import { useMediaQuery } from "@mui/material";

type Props = {
  children: any;
};

export default function SettingsContainer({ children }: Props) {
  const isDesktop = useMediaQuery("(min-width:1024px)");
  return (
    <main className="container">
      <div className={cls.container}>
        {isDesktop && (
          <>
            <div className={cls.sidebar}>
              <Sidebar withLinks />
            </div>
            <div className={cls.line} />
          </>
        )}
        <div className={cls.body}>
          {React.Children.map(children, (child) =>
            child ? React.cloneElement(child) : null,
          )}
        </div>
      </div>
    </main>
  );
}
